import { render, staticRenderFns } from "./AllLeagues.vue?vue&type=template&id=0b8b6654&scoped=true&"
import script from "./AllLeagues.vue?vue&type=script&lang=js&"
export * from "./AllLeagues.vue?vue&type=script&lang=js&"
import style0 from "./AllLeagues.vue?vue&type=style&index=0&id=0b8b6654&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b6654",
  null
  
)

export default component.exports